import equipe from '../../assents/equipe.jpg'
import { useState } from "react";
import "./home.css";
import { useNavigate } from 'react-router-dom';

export function Home() {
  const [activeText, setActiveText] = useState(null);
  const navigate = useNavigate();

  const toggleText = (id) => {
    setActiveText(activeText === id ? null : id);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="body-home">
      <header className="white">
        <i className="fas fa-anchor"></i> Coral Guard
      </header>

      <div className="container-coral">
        <h2 className="bold-h2">Entenda</h2>
        <button className="button-quest" onClick={() => toggleText("text1")}>
          <i className="fas fa-anchor"></i> O que é o Coral Guard?
        </button>
        <div className={`text-content ${activeText === "text1" ? "show" : ""}`}>
          Coral Guard é um projeto dedicado à proteção e estudo dos corais.
        </div>

        <button className="button-quest" onClick={() => toggleText("text2")}>
          <i className="fas fa-question-circle"></i> O que são corais?
        </button>
        <div className={`text-content ${activeText === "text2" ? "show" : ""}`}>
          Os corais são animais marinhos que formam recifes, abrigando diversas espécies e protegendo as costas. Sensíveis a mudanças ambientais, são essenciais para a biodiversidade.
        </div>

        <button className="button-quest" onClick={() => toggleText("text3")}>
          <i className="fas fa-exclamation-triangle"></i> Problema
        </button>
        <div className={`text-content ${activeText === "text3" ? "show" : ""}`}>
          O branqueamento dos corais ocorre devido ao aumento da temperatura dos oceanos,
          poluição e acidificação das águas, levando à morte dos recifes e à perda de vida marinha. Isso afeta gravemente o
          turismo e a economia das comunidades costeiras.
        </div>

        <button className="button-quest" onClick={() => toggleText("text4")}>
          <i className="fas fa-chart-bar"></i> O branqueamento
        </button>
        <div className={`text-content ${activeText === "text4" ? "show" : ""}`}>
          25% das espécies marinhas dependem dos corais para sobreviver.
          54% dos corais já estão mortos, e até 2030 esse número pode chegar a 70% se nada for feito.
          As algas marinhas produzem mais de 50% do oxigênio que respiramos.
        </div>

        <button className="button-quest" onClick={() => toggleText("text5")}>
          <i className="fas fa-star"></i> Solução
        </button>
        <div className={`text-content ${activeText === "text5" ? "show" : ""}`}>
          A conscientização é essencial para combater o branqueamento dos corais. Educação, turismo sustentável e a redução da pegada de carbono são fundamentais, assim como a colaboração entre organizações e o governo
        </div>


        <div className="library-section">
          <h2 className="bold-h2">Conheça a biblioteca Coral Guard</h2>
          <p>Descubra tudo sobre os corais! Nossa biblioteca oferece guias educativos, artigos científicos, vídeos e
            ferramentas interativas para você aprender de forma envolvente.</p>
          <p className="explore">
            <strong>Explore conteúdos sobre conservação marinha!</strong>
          </p>
          <div onClick={() => handleNavigation("/biblioteca")} className="explore-button">
            Explorar Biblioteca
          </div>
        </div>

        <div className="intro">Há muito o que explorar com o Coral Guard</div>

        <div className="about-section">
          <h2 className="bold-h2">Nos conheça!</h2>
          <div className="info-card">
            <img src={equipe} alt="Equipe" />
            <div className="info-text">
              <p>Somos a DNA Bots, uma equipe de robótica de Betim, MG. Formada por alunos do 8º ao 1º ano do ensino médio.
                Participantes da FLLC (First Lego League Challenge) uma competição com o objetivo de usarmos ciência e
                tecnologia para resolver problemas reais.</p>
              <p>Nosso projeto busca conscientizar sobre o branqueamento de corais, incentivando a preservação desses
                ecossistemas. E também o mapeamento desses corais no processo de branqueamento, promovendo educação ambiental
                e colaboração.</p>
            </div>
          </div>
          <div className="buttons">
            <p onClick={() => handleNavigation("/register")} className="start-button">Comece por aqui</p>
            <p onClick={() => handleNavigation("/login")} className="login-link">Já tenho uma conta</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
